import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {AccessManagementService} from '../services/access-management.service';

@Injectable({
  providedIn: 'root',
})
export class SalaryRecruiterPermissionsGuard  {
  constructor(private access: AccessManagementService) {}
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const accessData = route.parent?.data['accessData'];
    return accessData
      ? this.access.salaryRecruiterReadAccess(accessData)
      : true;
  }
}
